import withAnimation from 'HOCs/withAnimation';
import React from 'react';
import FaqsCard from './FaqsCard';

const Faqs = () => {
  const faqsList = [
    {
      q: 'What is this tool for?',
      a: 'This tool is for creating Twitter banner templates that help make your profile stand out and be more noticeable on the platform.'
    },
    {
      q: 'How do I use the tool?',
      a: 'To use the tool, simply choose a template that you like and customize it with your own text and images. You can then download the finished banner and upload it to your Twitter profile.'
    },
    {
      q: 'Can I customize the templates?',
      a: 'Yes, you can fully customize the templates to fit your needs. You can add your own text and images, as well as change the font, colors, and layout of the banner.'
    },
    {
      q: 'Can I use my own images in the banner?',
      a: 'Yes, you can use your own images in the banner by uploading them to the tool. Just make sure that the images are in a supported format (such as JPG or PNG) and that they meet the size requirements for Twitter banners.'
    },
    {
      q: 'Is there a limit to the number of templates I can use?',
      a: "There is no limit to the number of templates you can use. You can use as many templates as you like and customize them to your heart's content."
    },
    {
      q: 'Is there a cost to use this tool?',
      a: 'There is no cost to use this tool. It is completely free to use.'
    },
    {
      q: 'Are the banners I create with this tool free to use on my Twitter profile?',
      a: 'Yes, the banners you create with this tool are free to use on your Twitter profile. You are welcome to use them as often as you like.'
    }
  ];

  return (
    <section
      className="leading-relaxed max-w-screen-xl my-10 mx-auto px-4 lg:px-8 md:my-32"
      id="faqs">
      <div className="space-y-3 text-center">
        <h1 className="text-light text-3xl font-semibold">Frequently Asked Questions</h1>
        <p className="text-gray-600 max-w-lg mx-auto text-lg">
          Answered all frequently asked questions, Still confused? feel free to contact us.
        </p>
      </div>
      <div className="mt-14 max-w-2xl mx-auto">
        {faqsList.map((item, index) => (
          <FaqsCard idx={index} faq={item} key={index} />
        ))}
      </div>
    </section>
  );
};

export default withAnimation(Faqs);
